// import React, { useEffect, useState } from 'react';
// import 'react-toastify/dist/ReactToastify.css';
// import { fetchbanner, Referandearnleadcreation, useDashboard, getdata } from '../../Global/Index';
// import MySlider from './Slider';
// import './Slider.css'
// import './ReferAndEarnForm.css'
// import { useTheme } from '@mui/material/styles';
// import { toast } from 'react-toastify';
// import successgif from '../../Images/payment successful.gif';
// import PropTypes from 'prop-types';
 
// const Showreferandearn = ({setIsOpen}) => {
//   const [selectedLoanId, setSelectedLoanId] = useState(null);
//   const [index, setIndex] = useState(0);
//   const [message, setMessage] = useState({});
 
//   const handleSubmit = async () => {
//     if(!selectedLoanId){
//       alert('Please select at least one loan id');
//       return;
//     }
//     setIndex(1);
//   };
 
//   const theme = useTheme();
//   const { data, isLoading, error } = useDashboard();
//   if (error) {
//     console.log('Something went wrong');
//   }
//   const loandata = data?.response?.data?.loanList || [];
 
//   // Assuming this function is called on form submission
//   async function handleFormSubmit(event) {
//     event.preventDefault();
//     const form = event.target;
//     const data = await getdata();
//     let MobileNumber = ''
//     console.log(`data from getdata is ${JSON.stringify(data)}`);
//     if (data?.response?.status === '200') {
//       MobileNumber = data.response.data.MobileNumber;
//     }
 
//     if (form instanceof HTMLFormElement) {
//       const formData = new FormData(form);
//       const data = {
//         firstName: formData.get('firstName'),
//         lastName: formData.get('lastName'),
//         mobileNumberoftarget: formData.get('mobileNumber'),
//         mobileNumberofuser: MobileNumber,
//         applicationid: selectedLoanId
//       };
//       try {
//         const result = await Referandearnleadcreation(data);
//         console.log(`result of refer and earn lead creation`, JSON.stringify(result));
//         if (result.response.status === "200") {
//           setIndex(2);
//           setMessage({ status: result.status, message: result.Message, referid: result.LeadId });
//         } else if (result.response.status === 410) {
//           setMessage({ status: result.response.status, message: result.response.message });
//           setIndex(2);
//         } else {
//           toast.error('Unable to perform this operation at this time. Please try again later!');
//           setIsOpen(false);
//         }
//       } catch (error) {
//         console.error('Error creating lead:', error);
//       }
//     } else {
//       console.error('Event target is not a form element');
//     }
//   }
//   function renderContent() {
//     if (isLoading) {
//       return (
//         <div className="loanidselect" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
//           Please Wait .....
//         </div>
//       );
//     }
 
//     if (index === 0) {
//       return (
//         <div className="loanidselect" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
//           <h3 style={{ textAlign: 'center' }}>Please Select at least one Id before proceeding</h3>
//           {loandata.map((loan, idx) => (
//             <button
//               key={idx + 1}
//               className='loanidselectCard'
//               onClick={() => { setSelectedLoanId(loan.LoanAccountNumber) }}
//               style={{
//                 backgroundColor: selectedLoanId === loan.LoanAccountNumber ? '#90ee90a1' : theme.palette.background.default,
//                 color: selectedLoanId === loan.LoanAccountNumber ? 'green' : theme.palette.primary.main,
//                 border: 'none'
//               }}
//             >
//               <p>{loan.LoanAccountNumber}</p>
//               <p>{loan.LoanAccountName}</p>
//             </button>
//           ))}
//           <button
//             onClick={handleSubmit}
//             style={{
//               fontWeight: '600',
//               color: theme.palette.primary.main,
//               backgroundColor: theme.palette.background.default,
//               border: 'none',
//               padding: '1vh 2vh'
//             }}
//           >
//             Next <i className="bi bi-arrow-right" style={{ marginLeft: '.4vw', alignItem: 'center' }} />
//           </button>
//         </div>
//       );
//     }
 
//     if (index === 1) {
//       return (
//         <div className="loanidselect" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
//           <form className="referandearnform" onSubmit={handleFormSubmit}>
//             <label htmlFor="firstName">First Name:</label>
//             <input type="text" id="firstName" name="firstName" required style={{ backgroundColor: theme.palette.background.default, color: theme.palette.primary.main }} />
//             <br />
//             <label htmlFor="lastName">Last Name:</label>
//             <input type="text" id="lastName" name="lastName" required style={{ backgroundColor: theme.palette.background.default, color: theme.palette.primary.main }} />
//             <br />
//             <label htmlFor="mobileNumber">Mobile Number:</label>
//             <input type="number" id="mobileNumber" name="mobileNumber" required style={{ backgroundColor: theme.palette.background.default, color: theme.palette.primary.main }} />
//             <br />
//             <button type="submit">Submit</button>
//           </form>
//         </div>
//       );
//     }
 
//     if (index === 2) {
//       return (
//         <div className="loanidselect" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
//           {message.status === 200 && (
//             <div style={{ padding: '2vw' }}>
//               <img src={successgif} alt="payment-success-gif" className="payment-success-gif" style={{ margin: 'auto', display: 'flex' }} />
//               <p>
//                 You have successfully referred your friend with reference ID: <b>{message.referid}</b>
//               </p>
//               <p>
//                 Your referral award will be credited once the referrer gets the loan disbursed from India Shelter.
//               </p>
//             </div>
//           )}
//           <div>
//             {message.status === 410 && (
//               <div style={{ textAlign: 'center' }}>
//                 <b>Oops! {message.message}</b>.
//                 <p>Please try again later.</p>
//               </div>
//             )}
//           </div>
//         </div>
//       );
//     }
 
//     return null;
//   }
 
//   return (
//     <>
//       {renderContent()}
//     </>
//   );
 
// };
 
// Showreferandearn.propTypes = {
//   setIsOpen: PropTypes.func.isRequired,
// };
 
 
// export default function Banner() {
//   const ref = React.createRef();
//   const [isOpen, setIsOpen] = useState(true);
//   const [banner, setBanner] = useState(null);
//   const [image, setImage] = useState([]); // Use state for image array
//   const [isreferandearn, setIsreferandearn] = useState(false);
 
 
//   const referandearn = () => {
//     setIsreferandearn(true);
 
//   }
 
//   useEffect(() => {
//     const fetchBannerData = async () => {
//       try {
//         const datas = await fetchbanner();
//         if (datas.response.status === "200") {
//           setBanner(datas.response.data.result);
//           const currentDate = new Date();
//           if (datas) {
//             const urls = datas.response.data.result
//               .filter(data =>
//                 data.Banner_Active === "Yes" &&
//                 new Date(data.Banner_Start_Date) < currentDate &&
//                 new Date(data.Banner_End_Date) > currentDate &&
//                 data.Banner_Visible_Everytime === "Yes"
//                 // (data.Banner_Url.endsWith('.jpg') || data.Banner_Url.endsWith('.png') || data.Banner_Url.endsWith('.gif'))
 
//               )
//               .map(data => data.Banner_Url);
 
//             setImage(urls); // Update the state with the filtered URLs
//           }
 
//         }
 
//       } catch (error) {
//         console.error('Error fetching banner data:', error);
//       }
//     };
 
//     fetchBannerData();
 
 
//   }, []);
 
 
//   const handleClickOutside = (event) => {
//     if (ref.current && !ref.current.contains(event.target)) {
//       setIsOpen(false);
//     }
//   };
 
//   useEffect(() => {
//     document.addEventListener('click', handleClickOutside, true);
//     return () => {
//       document.removeEventListener('click', handleClickOutside, true);
//     };
//   }, [ref]);
 
 
 
 
 
//   if (banner == null || image.length === 0) {
//     return (
//       <div>{null}</div>
//     )
//   }
//   return (
//     <>
//       {isOpen && (<div className="emailoutercontainer"  >
 
//         {isreferandearn ? (<div ref={ref} >
//           {isreferandearn && (<Showreferandearn setIsOpen={setIsOpen} />)}
//         </div>) : <div className="carouselmaincontainer" ref={ref}  >
//           {
//             <MySlider image={image} referandearn={referandearn} />
//           }
//         </div>}
//       </div>)
 
//       }
//     </>
//   ) 
// }
 import React, { useEffect, useState, useRef, useCallback } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { fetchbanner, Referandearnleadcreation, useDashboard, getdata } from '../../Global/Index';
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-toastify';
import successgif from '../../Images/payment successful.gif';
import PropTypes from 'prop-types';

// ─── Media type helpers ───────────────────────────────────────────────────────
const videoExtensions = ['.mp4', '.mov', '.m4v', '.mkv', '.webm', '.avi'];
const audioExtensions = ['.mp3', '.wav', '.aac', '.m4a', '.flac', '.ogg'];

function getMediaType(url = '') {
  const lower = url.toLowerCase().split('?')[0];
  if (videoExtensions.some((ext) => lower.endsWith(ext))) return 'video';
  if (audioExtensions.some((ext) => lower.endsWith(ext))) return 'audio';
  return 'image';
}

// ─── Single slide ─────────────────────────────────────────────────────────────
function MediaSlide({ url, onSlideClick }) {
  const type = getMediaType(url);
  const videoRef = useRef(null);

  const handleFullscreen = (e) => {
    e.stopPropagation();
    const el = videoRef.current;
    if (!el) return;
    if (el.requestFullscreen) el.requestFullscreen();
    else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
    else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
  };

  if (type === 'video') {
    return (
      <div style={{ position: 'relative', width: '100%', background: '#000', lineHeight: 0 }}>
        <video
          ref={videoRef}
          src={url}
          controls
          style={{ width: '100%', height: 320, objectFit: 'cover', display: 'block' }}
        />
        {/* Only TOP half is clickable — bottom half keeps native video controls */}
        <div
          onClick={onSlideClick}
          title="Tap to know more"
          style={{
            position: 'absolute',
            top: 0, left: 0, right: 0,
            height: '80%',  
            zIndex: 2,
            cursor: 'pointer',
          }}
        />
        
        <div style={{
          position: 'absolute', top: 12, left: '50%', transform: 'translateX(-50%)',
          background: 'rgba(0,0,0,0.55)', color: '#fff', borderRadius: 20,
          padding: '4px 14px', fontSize: 11, zIndex: 3, letterSpacing: '0.3px',
          pointerEvents: 'none', whiteSpace: 'nowrap',
        }}>👆 Tap upper area to know more</div>
       
        <button
          onClick={handleFullscreen}
          style={{
            position: 'absolute', bottom: 48, right: 10,
            background: 'rgba(0,0,0,0.6)', color: '#fff', border: 'none',
            borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12,
            display: 'flex', alignItems: 'center', gap: 4, zIndex: 4,
          }}
        >⛶ Fullscreen</button>
      </div>
    );
  }

  if (type === 'audio') {
    return (
      <div style={{
        width: '100%', height: 320, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 16,
        background: 'linear-gradient(135deg, #1a1a2e, #16213e)', boxSizing: 'border-box',
      }}>
        <div style={{ fontSize: 56 }}>🎵</div>
        <audio src={url} controls autoPlay style={{ width: '85%', maxWidth: 400 }} />
      </div>
    );
  }


  return (
    <div onClick={onSlideClick} style={{ position: 'relative', cursor: 'pointer', lineHeight: 0 }}>
      <img
        src={url}
        alt="banner"
        style={{ width: '100%', height: 320, objectFit: 'cover', display: 'block' }}
      />
      <div style={{
        position: 'absolute', bottom: 10, left: '50%', transform: 'translateX(-50%)',
        background: 'rgba(0,0,0,0.55)', color: '#fff', borderRadius: 20,
        padding: '4px 14px', fontSize: 11, zIndex: 3, letterSpacing: '0.3px', whiteSpace: 'nowrap',
      }}>👆 Tap to know more</div>
    </div>
  );
}

// ─── Slider with auto-slide ───────────────────────────────────────────────────
const AUTO_SLIDE_INTERVAL = 3500;

function MediaSlider({ items, onSlideClick }) {
  const [idx, setIdx] = useState(0);
  const timerRef = useRef(null);
  const total = items.length;

  const goTo = useCallback((i) => setIdx((i + total) % total), [total]);
  const prev = (e) => { e.stopPropagation(); goTo(idx - 1); };
  const next = useCallback((e) => { if (e?.stopPropagation) e.stopPropagation(); goTo(idx + 1); }, [idx, goTo]);

  useEffect(() => {
    const currentType = getMediaType(items[idx]?.url || '');
    if (total <= 1 || currentType !== 'image') return;
    timerRef.current = setInterval(() => next({}), AUTO_SLIDE_INTERVAL);
    return () => clearInterval(timerRef.current);
  }, [idx, total, next, items]);

  if (total === 0) return null;

  return (
    <div style={{ position: 'relative', width: '100%', lineHeight: 0 }}>
      <MediaSlide url={items[idx].url} onSlideClick={onSlideClick} />

      {total > 1 && (
        <>
          <button onClick={prev} style={{
            position: 'absolute', top: '50%', left: 10, transform: 'translateY(-50%)',
            background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none', borderRadius: '50%',
            width: 36, height: 36, fontSize: 22, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5,
          }}>‹</button>
          <button onClick={next} style={{
            position: 'absolute', top: '50%', right: 10, transform: 'translateY(-50%)',
            background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none', borderRadius: '50%',
            width: 36, height: 36, fontSize: 22, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5,
          }}>›</button>
          <div style={{
            position: 'absolute', top: 10, right: 10,
            background: 'rgba(0,0,0,0.55)', color: '#fff',
            borderRadius: 12, padding: '2px 10px', fontSize: 12, zIndex: 5,
          }}>{idx + 1} / {total}</div>
          <div style={{
            position: 'absolute', bottom: 10, left: '50%', transform: 'translateX(-50%)',
            display: 'flex', gap: 6, zIndex: 5,
          }}>
            {items.map((_, i) => (
              <button key={i} onClick={(e) => { e.stopPropagation(); goTo(i); }} style={{
                width: i === idx ? 20 : 8, height: 8, borderRadius: 4,
                background: i === idx ? '#fff' : 'rgba(255,255,255,0.5)',
                border: 'none', cursor: 'pointer', padding: 0,
                transition: 'width 0.25s ease',
              }} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

// ─── Professional Refer & Earn UI ─────────────────────────────────────────────
const R = {
  primary: '#9b114a',
  primaryLight: '#fdeef4',
  primaryDark: '#6b0b32',
  success: '#16a34a',
  successLight: '#dcfce7',
  danger: '#dc2626',
  dangerLight: '#fee2e2',
  border: '#e5e7eb',
  text: '#111827',
  muted: '#6b7280',
  bg: '#ffffff',
  card: '#fafafa',

  wrap: {
    padding: '28px 24px 32px',
    background: '#fff',
    minHeight: 280,
    boxSizing: 'border-box',
  },
  heading: {
    fontSize: 17, fontWeight: 700, color: '#111827',
    margin: '0 0 6px', textAlign: 'center',
  },
  subheading: {
    fontSize: 12, color: '#6b7280', textAlign: 'center',
    margin: '0 0 20px', lineHeight: 1.5,
  },
  loanCard: (selected) => ({
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '12px 16px', marginBottom: 10, borderRadius: 10, cursor: 'pointer',
    border: `2px solid ${selected ? '#9b114a' : '#e5e7eb'}`,
    background: selected ? '#fdeef4' : '#fafafa',
    transition: 'all 0.18s ease',
    width: '100%', boxSizing: 'border-box',
  }),
  loanName: (selected) => ({
    fontSize: 13, fontWeight: 600,
    color: selected ? '#9b114a' : '#111827', margin: 0,
  }),
  loanId: (selected) => ({
    fontSize: 11, color: selected ? '#c94a7e' : '#6b7280', margin: '2px 0 0',
  }),
  checkCircle: (selected) => ({
    width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
    border: `2px solid ${selected ? '#9b114a' : '#d1d5db'}`,
    background: selected ? '#9b114a' : 'transparent',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#fff', fontSize: 11,
  }),
  nextBtn: {
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
    marginTop: 18, width: '100%', padding: '12px',
    background: '#9b114a', color: '#fff', border: 'none',
    borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: 'pointer',
    transition: 'background 0.18s',
  },
  fieldGroup: { marginBottom: 16 },
  label: {
    display: 'block', fontSize: 12, fontWeight: 600,
    color: '#374151', marginBottom: 5,
  },
  input: {
    width: '100%', padding: '10px 14px', fontSize: 14,
    border: '1.5px solid #e5e7eb', borderRadius: 8, outline: 'none',
    boxSizing: 'border-box', color: '#111827', background: '#fff',
    transition: 'border-color 0.15s',
  },
  submitBtn: {
    width: '100%', padding: '12px', background: '#9b114a',
    color: '#fff', border: 'none', borderRadius: 10,
    fontSize: 14, fontWeight: 600, cursor: 'pointer', marginTop: 8,
  },
  successWrap: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    padding: '10px 0 4px', textAlign: 'center', gap: 6,
  },
  refBadge: {
    display: 'inline-block', padding: '4px 14px',
    background: '#fdeef4', color: '#9b114a',
    borderRadius: 20, fontWeight: 700, fontSize: 13, marginTop: 4,
  },
  errorWrap: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    padding: '24px 0', textAlign: 'center', gap: 8,
  },
  errorIcon: { fontSize: 44 },
};
const Showreferandearn = ({ setIsOpen }) => {
  const [selectedLoanId, setSelectedLoanId] = useState(null);
  const [index, setIndex] = useState(0);
  const [message, setMessage] = useState({});
  const { data, isLoading, error } = useDashboard();
  if (error) console.log('Something went wrong');
  const loandata = data?.response?.data?.loanList || [];

  const handleSubmit = () => {
    if (!selectedLoanId) { toast.warn('Please select a loan account first.'); return; }
    setIndex(1);
  };

  async function handleFormSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const userData = await getdata();
    let MobileNumber = '';
    if (userData?.response?.status === '200') MobileNumber = userData.response.data.MobileNumber;
    if (form instanceof HTMLFormElement) {
      const formData = new FormData(form);
      const payload = {
        firstName: formData.get('firstName'),
        lastName: formData.get('lastName'),
        mobileNumberoftarget: formData.get('mobileNumber'),
        mobileNumberofuser: MobileNumber,
        applicationid: selectedLoanId,
      };
      try {
        const result = await Referandearnleadcreation(payload);
        if (result.response.status === '200') {
          setIndex(2);
          setMessage({ status: result.status, message: result.Message, referid: result.LeadId });
        } else if (result.response.status === 410) {
          setMessage({ status: result.response.status, message: result.response.message });
          setIndex(2);
        } else {
          toast.error('Unable to perform this operation at this time. Please try again later!');
          setIsOpen(false);
        }
      } catch (err) { console.error('Error creating lead:', err); }
    }
  }

  if (isLoading) return (
    <div style={{ ...R.wrap, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, color: R.muted }}>
      <span style={{ fontSize: 18, animation: 'spin 1s linear infinite', display: 'inline-block' }}>⏳</span>
      Loading your accounts...
    </div>
  );

  // Step 0 — Select loan
  if (index === 0) return (
    <div style={R.wrap}>
      <p style={R.heading}>🎁 Refer & Earn</p>
      <p style={R.subheading}>Select the loan account you want to refer with, then invite a friend.</p>
      <div style={{ maxHeight: 220, overflowY: 'auto', paddingRight: 2 }}>
        {loandata.map((loan, i) => {
          const sel = selectedLoanId === loan.LoanAccountNumber;
          return (
            <button key={i} onClick={() => setSelectedLoanId(loan.LoanAccountNumber)} style={R.loanCard(sel)}>
              <div style={{ textAlign: 'left' }}>
                <p style={R.loanName(sel)}>{loan.LoanAccountName}</p>
                <p style={R.loanId(sel)}>{loan.LoanAccountNumber}</p>
              </div>
              <div style={R.checkCircle(sel)}>{sel ? '✓' : ''}</div>
            </button>
          );
        })}
      </div>
      <button onClick={handleSubmit} style={R.nextBtn}>
        Continue &nbsp;→
      </button>
    </div>
  );

  // Step 1 — Fill form
  if (index === 1) return (
    <div style={R.wrap}>
      <p style={R.heading}>👤 Friend's Details</p>
      <p style={R.subheading}>Enter your friend's information to complete the referral.</p>
      <form onSubmit={handleFormSubmit}>
        <div style={R.fieldGroup}>
          <label style={R.label} htmlFor="firstName">First Name</label>
          <input style={R.input} type="text" id="firstName" name="firstName" placeholder="e.g. Rahul" required />
        </div>
        <div style={R.fieldGroup}>
          <label style={R.label} htmlFor="lastName">Last Name</label>
          <input style={R.input} type="text" id="lastName" name="lastName" placeholder="e.g. Sharma" required />
        </div>
        <div style={R.fieldGroup}>
          <label style={R.label} htmlFor="mobileNumber">Mobile Number</label>
          <input style={R.input} type="number" id="mobileNumber" name="mobileNumber" placeholder="10-digit mobile number" required />
        </div>
        <button type="submit" style={R.submitBtn}>Submit Referral</button>
      </form>
    </div>
  );

  // Step 2 — Result
  if (index === 2) return (
    <div style={R.wrap}>
      {message.status === 200 && (
        <div style={R.successWrap}>
          <img src={successgif} alt="success" style={{ width: 90, height: 90, objectFit: 'contain' }} />
          <p style={{ fontSize: 16, fontWeight: 700, color: R.success, margin: '4px 0 0' }}>Referral Submitted!</p>
          <p style={{ fontSize: 13, color: R.muted, margin: '4px 0 0', lineHeight: 1.5 }}>
            Your referral ID:
          </p>
          <span style={R.refBadge}>{message.referid}</span>
          <p style={{ fontSize: 12, color: R.muted, marginTop: 10, lineHeight: 1.6 }}>
            Your reward will be credited once your friend's loan is disbursed by India Shelter.
          </p>
        </div>
      )}
      {message.status === 410 && (
        <div style={R.errorWrap}>
          <div style={R.errorIcon}>⚠️</div>
          <p style={{ fontSize: 15, fontWeight: 700, color: R.danger, margin: 0 }}>
            {message.message}
          </p>
          <p style={{ fontSize: 13, color: R.muted, margin: '6px 0 0' }}>Please try again later.</p>
          <button onClick={() => setIsOpen(false)} style={{ ...R.submitBtn, marginTop: 16, background: R.danger, width: 'auto', padding: '10px 24px' }}>
            Close
          </button>
        </div>
      )}
    </div>
  );

  return null;
};

Showreferandearn.propTypes = { setIsOpen: PropTypes.func.isRequired };

// ─── Mini player ──────────────────────────────────────────────────────────────
function MiniThumb({ url }) {
  const type = getMediaType(url);
  const s = { width: '100%', height: 100, objectFit: 'cover', display: 'block' };
  if (type === 'video') return <video src={url} muted style={s} />;
  if (type === 'audio') return <div style={{ ...s, background: 'linear-gradient(135deg,#1a1a2e,#16213e)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36 }}>🎵</div>;
  return <img src={url} alt="mini" style={s} />;
}

// ─── Main Banner ──────────────────────────────────────────────────────────────
export default function Banner() {
  const modalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(true);
  const [isMinimised, setIsMinimised] = useState(false);
  const [mediaItems, setMediaItems] = useState([]);
  const [isReferAndEarn, setIsReferAndEarn] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const datas = await fetchbanner();
        if (datas.response.status === '200') {
          const now = new Date();
          const active = datas.response.data.result
            .filter(d =>
              d.Banner_Active === 'Yes' &&
              new Date(d.Banner_Start_Date) < now &&
              new Date(d.Banner_End_Date) > now &&
              d.Banner_Visible_Everytime === 'Yes'
            )
            .map(d => ({ url: d.Banner_Url, type: getMediaType(d.Banner_Url) }));
          setMediaItems(active);
        }
      } catch (err) {
        console.error('Error fetching banner data:', err);
      }
    })();
  }, []);

  const handleClickOutside = useCallback((event) => {
    if (!isMinimised && modalRef.current && !modalRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  }, [isMinimised]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => document.removeEventListener('click', handleClickOutside, true);
  }, [handleClickOutside]);

  if (mediaItems.length === 0) return null;

  // ── Minimised ─────────────────────────────────────────────────────────────
  if (isMinimised) {
    return (
      <div onClick={() => setIsMinimised(false)} title="Click to expand" style={{
        position: 'fixed', bottom: 20, right: 20, zIndex: 1300,
        width: 190, borderRadius: 12, overflow: 'hidden',
        boxShadow: '0 8px 28px rgba(0,0,0,0.4)', cursor: 'pointer',
        border: '2px solid rgba(255,255,255,0.15)', background: '#1a1a2e',
      }}>
        <MiniThumb url={mediaItems[0].url} />
        <div style={{ padding: '5px 10px', fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.8)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Click to expand</span>
          <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#4ade80', display: 'inline-block' }} />
        </div>
      </div>
    );
  }

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)',
      backdropFilter: 'blur(4px)', zIndex: 1200,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16, boxSizing: 'border-box',
    }}>
      <div ref={modalRef} style={{
        position: 'relative', borderRadius: 14, overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
        width: '100%', maxWidth: 580, background: '#fff',
      }}>
        {/* Top bar */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '6px 12px',
          background: '#fff', borderBottom: '1px solid #f0f0f0',
        }}>
          {/* Back button when in refer & earn */}
          {isReferAndEarn
            ? <button onClick={() => setIsReferAndEarn(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: '#c0392b', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4, padding: 0 }}>
                ← Back
              </button>
            : <div />
          }
          <div style={{ display: 'flex', gap: 4 }}>
            <button onClick={() => setIsMinimised(true)} title="Minimise" style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: '#999', width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>–</button>
            <button onClick={() => setIsOpen(false)} title="Close" style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 15, color: '#c0392b', width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
          </div>
        </div>

        {/* Content */}
        {isReferAndEarn
          ? <Showreferandearn setIsOpen={setIsOpen} />
          : <MediaSlider items={mediaItems} onSlideClick={() => setIsReferAndEarn(true)} />
        }
      </div>
    </div>
  );
}